import React from 'react';
import { SvgIcon } from '@adsk/bim360-matrix-react-components';

const FilterSearchIcon = () => <SvgIcon width="15px" height="15px" className="FilterSearchIcon" svgId="magnifying-glass" />;

FilterSearchIcon.displayName = 'FilterSearchIcon';

export default FilterSearchIcon;
